module.exports = __webpack_public_path__ + "img/DSC_1850.7c3f4b73.JPG";